<template>
  <span class="flip-value-wrap">
    <transition name="flip-value" mode="out-in">
      <span :key="resolvedKey" class="flip-value-digit">{{ display }}</span>
    </transition>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  display: {
    type: [String, Number],
    required: true,
  },
  valueKey: {
    type: [String, Number],
    default: null,
  },
})

const resolvedKey = computed(() => (props.valueKey ?? props.display))
</script>

<style scoped>
.flip-value-wrap {
  display: inline-block;
  perspective: 600px;
}

.flip-value-digit {
  display: inline-block;
  backface-visibility: hidden;
  transform-origin: 50% 50%;
}

.flip-value-enter-active,
.flip-value-leave-active {
  transition: transform 380ms cubic-bezier(0.22, 1, 0.36, 1), opacity 380ms ease;
}

.flip-value-enter-from {
  transform: rotateX(-90deg);
  opacity: 0;
}

.flip-value-leave-to {
  transform: rotateX(90deg);
  opacity: 0;
}
</style>
